import lucenceCardioHemeRiskQuestions, { LucenceCardioHemeRISKQuestionFieldAnswers } from './initial/questions';

const LucenceCardioHemeRISKQuestions = [...lucenceCardioHemeRiskQuestions];
export default LucenceCardioHemeRISKQuestions;

export type { LucenceCardioHemeRISKQuestionFieldAnswers };
